import {
    type ChatMessage,
    convertThreadMessagesToChatMessages,
    listAllMastraThreadMessages,
    type MastraThreadMessage,
} from '@fruitful/llm-service-shared';
import { useCallback } from 'react';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

export interface FetchThreadMessagesResult {
    chatMessages: ChatMessage[];
    rawMessages: MastraThreadMessage[];
}

export const useMastraThreadMessages = () => {
    const mastraClient = useMastraClient();

    return useCallback(
        async ({
            agentId,
            threadId,
        }: {
            agentId: string;
            threadId: string;
        }): Promise<FetchThreadMessagesResult> => {
            try {
                const thread = mastraClient.getMemoryThread({
                    threadId,
                    agentId,
                });
                const messages = await listAllMastraThreadMessages(
                    async (params) => await thread.listMessages(params),
                );
                const chatMessages =
                    convertThreadMessagesToChatMessages(messages);
                return {
                    chatMessages,
                    rawMessages: messages as MastraThreadMessage[],
                };
            } catch (err) {
                captureException(err);
                throw err;
            }
        },
        [mastraClient],
    );
};
